import React from 'react';
import { View, Text, Modal, TouchableOpacity, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { Crown, X } from 'lucide-react-native';

interface LimiteRachasModalProps {
  visible: boolean;
  onClose: () => void;
  onUpgrade?: () => void;
  limite: number;
  atual: number;
}

export function LimiteRachasModal({ visible, onClose, onUpgrade, limite, atual }: LimiteRachasModalProps) {
  const router = useRouter();
  const { colors } = useTheme();

  const handleAssinarPremium = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      onClose();
      router.navigate('assinatura');
    }
  };

  const styles = StyleSheet.create({
    overlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
    },
    modal: {
      backgroundColor: colors.surface,
      borderRadius: 24,
      padding: 32,
      width: '100%',
      maxWidth: 400,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: colors.border,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.3,
      shadowRadius: 8,
      elevation: 8,
    },
    iconContainer: {
      width: 64,
      height: 64,
      borderRadius: 32,
      backgroundColor: colors.error + '20',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 24,
    },
    title: {
      fontSize: 24,
      fontFamily: 'Inter-Bold',
      textAlign: 'center',
      marginBottom: 16,
      color: colors.text,
    },
    message: {
      fontSize: 16,
      textAlign: 'center',
      marginBottom: 8,
      color: colors.text,
      fontFamily: 'Inter-Regular',
      lineHeight: 24,
    },
    highlight: {
      fontFamily: 'Inter-Bold',
      color: colors.primary,
    },
    submessage: {
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 32,
      color: colors.textSecondary,
      fontFamily: 'Inter-Regular',
      lineHeight: 20,
    },
    buttonContainer: {
      width: '100%',
      gap: 12,
    },
    button: {
      width: '100%',
      paddingVertical: 16,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: 8,
    },
    cancelButton: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: colors.border,
    },
    cancelButtonText: {
      color: colors.textSecondary,
      fontSize: 16,
      fontFamily: 'Inter-SemiBold',
    },
    premiumButton: {
      backgroundColor: colors.primary,
      elevation: 4,
      shadowColor: colors.primary,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 8,
    },
    premiumButtonText: {
      color: '#FFFFFF',
      fontSize: 16,
      fontFamily: 'Inter-Bold',
    },
  });

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modal}>
          <View style={styles.iconContainer}>
            <X size={32} color={colors.error} />
          </View>

          <Text style={styles.title}>Limite Atingido</Text>

          <Text style={styles.message}>
            Você já atingiu o limite de {limite} racha{limite > 1 ? 's' : ''} do plano gratuito.
          </Text>

          <Text style={styles.submessage}>
            Faça um upgrade para o <Text style={styles.highlight}>Premium Anual</Text> e crie rachas ilimitados!
          </Text>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.premiumButton]}
              onPress={handleAssinarPremium}
              activeOpacity={0.8}
            >
              <Crown size={20} color="#FFFFFF" />
              <Text style={styles.premiumButtonText}>Quero Rachas Ilimitados</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.cancelButton]}
              onPress={onClose}
              activeOpacity={0.7}
            >
              <Text style={styles.cancelButtonText}>Agora não</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}